import React from 'react'
import { useSelector } from 'react-redux';
import Logo from '../../shared/logo/Logo';
import Map from '../../shared/map/Map';
import Text from '../../shared/text/Text';
import Support from '../../shared/support/Support';
import classes from './Home.module.css';

const Home = () => {

    const { texts } = useSelector(state => state.translate);

    return (

        <div className={classes.Home}>
            <Text elementType='h1' className={classes.TitleText}>{texts.welcome}</Text>
            <div className={classes.MapWrapper}>
                <Map />
            </div>
            <Support />
        </div>
    )
}
export default Home;